import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import CardHeaderBackgroundComponent from "../../../components/cardHeaderBackground";
import ContainerComponent from "../../../components/conatiner";
import HeaderComponent from "../../../components/header";
import InputComponent from "../../../components/input";
import { useNavigate } from "react-router-dom";
import { ChangeEvent, useEffect, useState } from "react";
import TableComponent from "../../../components/table";
import { ManagersAllCostCentersService } from "../../../services/managers/cost_centers";
import { ToastErro } from "../../../components/toast";
import { ManagersEmployeesService, ManagersEmployeesUserService } from "../../../services/managers/employees";
import LoadingComponent from "../../../components/loading";
import ModalComponent from "../../../components/modal";

const ManagersEmployeesPage = () => {

    const navigate = useNavigate();

    const [loadingEmployees, setLoadingEmployees] = useState<boolean>(true);
    const [loadingCostCenters, setLoadingCostCenters] = useState<boolean>(true);

    const [loadingInfo, setLoadingInfo] = useState<boolean>(true);

    const [employees, setEmployees] = useState<any>([]);
    const [costCenters, setCostCenters] = useState<any>([]);

    const [employee, setEmployee] = useState<any>(null);

    // variaveis de pesquisa
    const [name, setName] = useState<string>('');
    const [costCenter, setCostCenter] = useState<number>(null!);
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // função para pesquisar os funcionários
    const getEmployees = async () => {

        setLoadingEmployees(true);

        await ManagersEmployeesService(name, costCenter, page).then(resp => {
            setEmployees(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoadingEmployees(false);

    }
    // função para pesquisar os funcionários

    // função para pesquisar os centros de custo
    const getCostCenters = async () => {

        setLoadingCostCenters(true);

        await ManagersAllCostCentersService().then(resp => {
            setCostCenters(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoadingCostCenters(false);

    }
    // função para pesquisar os centros de custo

    // função para pesquisar usuário
    const getUser = async (id: number) => {

        setLoadingInfo(true);

        (window as any).$("#modalInfo").modal('show');

        await ManagersEmployeesUserService(id).then(resp => {
            setEmployee(resp.data);
            setLoadingInfo(false);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            (window as any).$("#modalInfo").modal('show');
        });

    }
    // função para pesquisar usuário

    useEffect(() => {
        getEmployees();
    }, [page]);

    useEffect(() => {
        getCostCenters();
    }, []);

    return (
        <>
            <HeaderComponent
                title="Funcionários"
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        {
                            loadingCostCenters

                                ?

                                <LoadingComponent />

                                :

                                <div className="row">
                                    <InputComponent
                                        label="Nome"
                                        col={8}
                                        size={"small"}
                                        defaultValue={name}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                                    />                                    
                                    <div className="col-md-4">
                                        <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getEmployees()}>Pesquisar</button>
                                        <button className="btn btn-danger" type="button" style={{ marginLeft: 15 }} onClick={() => (window as any).location.reload()}>Limpar</button>
                                    </div>
                                </div>
                        }
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Funcionários"
                        columns={['ID', 'Nome', 'CPF', 'Ações']}
                        loading={loadingEmployees}
                        last_page={employees?.last_page}
                        page={page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            employees?.data?.map((e: any) => {
                                return (
                                    <tr key={e.id}>
                                        <td className="px-4">{e.id}</td>
                                        <td className="px-4">{e.name}</td>
                                        <td className="px-4">{e.cpf}</td>
                                        <td className="px-4">
                                            <button className="btn btn-text-info" type="button" title="Informações" onClick={() => getUser(e.id)}>
                                                <i className="material-icons">info</i>
                                            </button>
                                            <button className="btn btn-text-warning" type="button" title="Editar" onClick={() => navigate(`/managers/employees/${e.id}`)}><i className="material-icons">edit</i></button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>

                    <ModalComponent
                        title="Informações do Funcionário"
                        id="modalInfo"
                        big
                    >
                        {
                            loadingInfo

                                ?

                                <LoadingComponent />

                                :

                                <>
                                    <div className="row mt-4">
                                        <InputComponent
                                            label="Nome"
                                            col={12}
                                            defaultValue={employee?.user?.name}
                                            disabled
                                        />
                                    </div>
                                    <div className="row">
                                        <InputComponent
                                            label="CPF"
                                            col={3}
                                            defaultValue={employee?.user?.cpf}
                                            disabled
                                        />
                                        <InputComponent
                                            label="Banco"
                                            col={3}
                                            defaultValue={employee?.user?.bank}
                                            disabled
                                        />
                                        <InputComponent
                                            label="Agência"
                                            col={3}
                                            defaultValue={employee?.user?.agency}
                                            disabled
                                        />
                                        <InputComponent
                                            label="Conta"
                                            col={3}
                                            defaultValue={employee?.user?.account}
                                            disabled
                                        />
                                    </div>
                                    <h5>Centros de Custo</h5>
                                    <div className="row mt-4">
                                        <div className="col-md-12">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">ID</th>
                                                        <th scope="col">Centro de Custo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        employee?.costCenters?.map((e: any) => {
                                                            return (
                                                                <tr key={e.id}>
                                                                    <td>{e.id}</td>
                                                                    <td>{e.description}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </>
                        }
                    </ModalComponent>
                </>
            </ContainerComponent>
        </>
    )

}

export default ManagersEmployeesPage;